import "./footer.scss";

const Footer = () => {
  return (
    <div className="footer">
      <span>Admin Dashboard</span>
      <span>© Ser Dev Admin Dashboard</span>
    </div>
  );
};

export default Footer;
